import { VIEW_KEY } from '@repo/types/enums/viewKey';
import { endOfWeek, isSameDay, isWithinInterval, startOfWeek } from 'date-fns';
import { useEffect, useState } from 'react';

export function useCurrentTimeIndicator(currentDate: Date, view: VIEW_KEY) {
  const [currentTimePosition, setCurrentTimePosition] = useState<number>(0);
  const [currentTimeVisible, setCurrentTimeVisible] = useState<boolean>(false);

  useEffect(() => {
    const calculateTimePosition = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const totalMinutes = hours * 60 + minutes;
      const dayStartMinutes = 0;
      const dayEndMinutes = 24 * 60;

      // Calculate position as percentage of day
      const position = ((totalMinutes - dayStartMinutes) / (dayEndMinutes - dayStartMinutes)) * 100;

      // Check if current day is in view based on the calendar view
      let isCurrentTimeVisible = false;

      if (view === VIEW_KEY.DAY) {
        isCurrentTimeVisible = isSameDay(now, currentDate);
      } else if (view === VIEW_KEY.WEEK) {
        const startOfWeekDate = startOfWeek(currentDate);
        const endOfWeekDate = endOfWeek(currentDate);
        isCurrentTimeVisible = isWithinInterval(now, {
          start: startOfWeekDate,
          end: endOfWeekDate,
        });
      }

      setCurrentTimePosition(position);
      setCurrentTimeVisible(isCurrentTimeVisible);
    };

    // Calculate immediately
    calculateTimePosition();

    // Update every minute
    const interval = setInterval(calculateTimePosition, 60000);

    return () => clearInterval(interval);
  }, [currentDate, view]);

  return { currentTimePosition, currentTimeVisible };
}
